import React from 'react';
import SvgIcon from 'components/SvgIcon/SvgIcon';
import styles from '../Footer.module.scss';

const SOCIALS = [
  {
    href: 'https://www.linkedin.com/company/twine-net',
    title: 'Twine on LinkedIn',
    icon: 'linkedin',
  },
  {
    href: 'https://www.instagram.com/jointwine',
    title: 'Twine on Instagram',
    icon: 'instagram',
  },
  {
    href: 'https://x.com/jointwine',
    title: 'Twine on X',
    icon: 'x',
  },
];

const FooterBottom = () => (
  <div className={styles.bottomBar}>
    <div className={styles.bottomLeft}>
      <div className={styles.brandLine}>
        <SvgIcon
          icon="logo"
          width="62"
          height="18"
          className={styles.wordmark}
        />
        <span>&copy; Clowdy Ltd. t/a Twine</span>
      </div>
      <p className={styles.legal}>
        <a href="/terms" title="Terms Of Service">
          Terms
        </a>
        <span aria-hidden="true"> · </span>
        <a href="/privacy" title="Privacy Policy">
          Privacy
        </a>
      </p>
    </div>
    <ul className={styles.socialRow}>
      {SOCIALS.map((social) => (
        <li key={social.icon}>
          <a
            className={styles.socialLink}
            rel="nofollow noopener noreferrer"
            href={social.href}
            target="_blank"
            title={social.title}
          >
            <SvgIcon size="16" icon={social.icon} />
          </a>
        </li>
      ))}
    </ul>
  </div>
);

export default FooterBottom;
